import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectTransactionsReferencesByAccountNumber } from 'src/app/state/selectors/billing-transactions-references.selectors';
import { filter, map, tap } from 'rxjs/operators';
import {
  getDocumentReferencesForOrderId,
  getThirdPartyDocumentReference,
} from './utils.service';
import { getBillingTransactionsReferencesRequest } from 'src/app/state/actions';
import {
  IBillingDocumentReference,
  IBillingDocumentReferences,
} from '../models/billing-transactions-references.model';

@Injectable()
export class TransactionReferenceService {
  private readonly store = inject(Store);

  getDocumentReferencesForOrderId(
    accountNumber: string,
    orderId: string
  ): Observable<IBillingDocumentReferences | undefined> {
    return this.store
      .select(selectTransactionsReferencesByAccountNumber(accountNumber))
      .pipe(
        filter(
          (transactionReferences) =>
            transactionReferences !== undefined &&
            transactionReferences.result !== null
        ),
        map((transactionReferences) =>
          getDocumentReferencesForOrderId(transactionReferences.result, orderId)
        )
      );
  }

  isTransactionReferencesLoaded(accountNumber: string) {
    return this.store
      .select(selectTransactionsReferencesByAccountNumber(accountNumber))
      .pipe(
        filter(
          (transactionReferences) =>
            transactionReferences === undefined ||
            (!transactionReferences.hasError &&
              transactionReferences.result === null &&
              !transactionReferences.isFetching) ||
            (transactionReferences.hasError &&
              transactionReferences.result === null)
        )
      );
  }

  fetchTransactionReferences(accountNumber: string) {
    this.store.dispatch(getBillingTransactionsReferencesRequest(accountNumber));
  }
}
